import { useContext } from 'react';
import { MembershipExtendedPackage } from 'common/interfaces/api';
import {
  checkIsSubbedIzanaviBefore,
  isPayingIzanavi,
  membershipPricePackagePeriod,
  paymentMembershipPrice,
} from 'common/utils/membership';
import useStore from 'store/timeline';

import { MembershipPaymentSectionContext } from '..';
import styles from './PaymentInfo.module.scss';

const PaymentInfo = () => {
  const {
    currentPackage,
    currentPaymentBy,
    izanaviPackage,
    choosingIzanaviPackage,
  } = useContext(MembershipPaymentSectionContext);
  const currentUser = useStore((state) => state.currentUser);
  const isReSubscription = currentUser?.is_subscribed_membership_before;
  if (!currentPackage) return <></>;
  const membershipSubPaymentInfo = () => {
    return (
      <div className={styles.info}>
        メンバーシップ{'\n'}
        {isReSubscription || currentPaymentBy === 'coin'
          ? ''
          : '無料体験終了後、'}
        {membershipPricePackagePeriod(currentPackage?.recurring)}
        毎に
        {paymentMembershipPrice(
          currentPackage,
          currentPaymentBy,
        )?.toLocaleString()}
        {currentPaymentBy === 'coin' ? 'コイン' : '円'}
        の支払いが自動的に発生します。
      </div>
    );
  };
  const izanaviSubPaymentInfo = () => {
    if (!izanaviPackage) return <></>;
    if (!isPayingIzanavi(currentUser) && !choosingIzanaviPackage) return <></>;
    const isSubbedPlusPackageBefore = checkIsSubbedIzanaviBefore(currentUser);
    return (
      <div className={styles.info}>
        IZANAVI{'\n'}
        {isSubbedPlusPackageBefore || currentPaymentBy === 'coin'
          ? ''
          : '無料体験終了後、'}
        1カ月毎に{izanaviPriceText(izanaviPackage)}
        {currentPaymentBy === 'coin' ? 'コイン' : '円'}
        の支払いが自動的に発生します。
      </div>
    );
  };
  return (
    <div className={styles.paymentInfo}>
      {membershipSubPaymentInfo()}
      {currentPaymentBy === 'credit' && izanaviSubPaymentInfo()}
    </div>
  );
};

const izanaviPriceText = (pack: MembershipExtendedPackage) => {
  if (
    pack.discounted_web_amount > 0 &&
    pack.web_amount > pack.discounted_web_amount
  ) {
    return pack.discounted_web_amount?.toLocaleString();
  }
  return pack.web_amount?.toLocaleString();
};

export default PaymentInfo;
